// src/rtkQuery/features/hooks/useOrdersService.ts

import {
  useGetOrdersForPatientQuery,
  useLazyGetOrdersForPatientQuery,
} from '@/rtkQuery/features/services/orders';

export const useOrdersService = (page = 1, pageSize = 10) => {
  const {
    data,
    error,
    isLoading,
    isError,
    isSuccess,
    refetch,
    status,
  } = useGetOrdersForPatientQuery({ page, pageSize });

  const [
    trigger,
    {
      data: lazyData,
      error: lazyError,
      isLoading: lazyLoading,
      isSuccess: lazySuccess,
      isError: lazyFail,
      status: lazyStatus,
    },
  ] = useLazyGetOrdersForPatientQuery();

  const errorMessage: string =
    (error as any)?.data?.message || (error as any)?.error || 'Could not fetch orders';

  const lazyErrorMessage: string =
    (lazyError as any)?.data?.message || (lazyError as any)?.error || 'Could not fetch orders';

  return { 
    orders: data ?? [],
    ordersIsLoading: isLoading,
    ordersIsError: isError,
    ordersIsSuccess: isSuccess,
    ordersError: error,
    ordersErrorMessage: errorMessage,
    ordersRefetch: refetch,
    ordersStatus: status,
     
    fetchOrders: trigger,
    ordersLazyData: lazyData,
    ordersLazyIsLoading: lazyLoading,
    ordersLazyIsSuccess: lazySuccess,
    ordersLazyIsError: lazyFail,
    ordersLazyError: lazyError,
    ordersLazyErrorMessage: lazyErrorMessage,
    ordersLazyStatus: lazyStatus,
  };
};
